import { Link } from "react-router-dom";
import LegalLayout, { Section } from "@/components/LegalLayout";
import { COMPANY } from "@/lib/legal";

const TOC = [
  { id: "penerimaan", label: "1. Penerimaan Syarat" },
  { id: "definisi", label: "2. Definisi" },
  { id: "kelayakan", label: "3. Kelayakan & Akun" },
  { id: "layanan", label: "4. Deskripsi Layanan" },
  { id: "penggunaan", label: "5. Penggunaan yang Diizinkan" },
  { id: "larangan", label: "6. Larangan & Anti-Spam" },
  { id: "byok", label: "7. Akun Pihak Ketiga (BYOK)" },
  { id: "langganan", label: "8. Langganan, Kredit & Harga" },
  { id: "pembayaran", label: "9. Pembayaran & Pajak" },
  { id: "refund", label: "10. Pengembalian Dana" },
  { id: "ki", label: "11. Kekayaan Intelektual" },
  { id: "data", label: "12. Data & Privasi" },
  { id: "penafian", label: "13. Penafian" },
  { id: "tanggungjawab", label: "14. Batasan Tanggung Jawab" },
  { id: "gantirugi", label: "15. Ganti Rugi" },
  { id: "penangguhan", label: "16. Penangguhan & Penghentian" },
  { id: "hukum", label: "17. Hukum & Penyelesaian Sengketa" },
  { id: "perubahan", label: "18. Perubahan Syarat" },
  { id: "kontak", label: "19. Kontak" },
];

const link = "text-sky-600 font-medium hover:underline";
const ul = "list-disc pl-5 space-y-1.5";

export default function TermsOfService() {
  return (
    <LegalLayout
      seoTitle={`Syarat & Ketentuan — ${COMPANY.brand}`}
      seoDesc={`Syarat & Ketentuan penggunaan layanan ${COMPANY.brand} — lead generation, scraping data bisnis, manajemen lead, serta WhatsApp & Email blast.`}
      path="/terms"
      title="Syarat & Ketentuan"
      subtitle={`Ketentuan hukum yang mengatur penggunaan platform ${COMPANY.brand}. Mohon dibaca dengan saksama sebelum menggunakan layanan kami.`}
      toc={TOC}
    >
      <Section id="penerimaan" title="1. Penerimaan Syarat">
        <p>
          Selamat datang di {COMPANY.brand} ({COMPANY.website}). Dengan membuat akun, mengakses, atau
          menggunakan layanan kami, Anda menyatakan telah membaca, memahami, dan menyetujui untuk terikat
          pada Syarat &amp; Ketentuan ini ("Syarat") beserta{" "}
          <Link to="/privacy" className={link}>Kebijakan Privasi</Link> dan{" "}
          <Link to="/refund" className={link}>Kebijakan Pengembalian Dana</Link> kami. Jika Anda tidak setuju,
          mohon untuk tidak menggunakan layanan.
        </p>
      </Section>

      <Section id="definisi" title="2. Definisi">
        <ul className={ul}>
          <li><b>"Kami"/"{COMPANY.brand}"</b> — penyedia platform {COMPANY.brand}.</li>
          <li><b>"Layanan"</b> — seluruh fitur, situs web, aplikasi, dan API yang kami sediakan.</li>
          <li><b>"Pengguna"/"Anda"</b> — orang atau badan usaha yang mendaftar dan menggunakan Layanan.</li>
          <li><b>"Lead"</b> — data kontak/bisnis yang dikumpulkan, diimpor, atau dikelola melalui Layanan.</li>
          <li><b>"Kredit"</b> — satuan kuota yang digunakan untuk menjalankan fitur tertentu (mis. scraping).</li>
        </ul>
      </Section>

      <Section id="kelayakan" title="3. Kelayakan & Akun">
        <p>
          Anda harus berusia minimal 18 tahun atau cukup umur secara hukum untuk mengikat kontrak. Anda
          bertanggung jawab penuh atas seluruh aktivitas pada akun Anda dan menjaga kerahasiaan kredensial.
          Beri tahu kami segera melalui {COMPANY.email} jika terjadi akses tidak sah. Anda wajib memberikan
          informasi yang akurat dan memperbaruinya bila berubah.
        </p>
      </Section>

      <Section id="layanan" title="4. Deskripsi Layanan">
        <p>{COMPANY.brand} adalah platform <i>lead generation</i> & <i>sales automation</i> untuk pasar Indonesia, yang mencakup antara lain:</p>
        <ul className={ul}>
          <li>Pencarian & pengumpulan data bisnis publik (mis. dari Google Maps, Instagram, Facebook).</li>
          <li>Manajemen lead (CRM ringan): penyimpanan, label, status, ekspor.</li>
          <li>WhatsApp Blast melalui koneksi akun Anda sendiri (BYOK, mis. Fonnte).</li>
          <li>Email Blast melalui Gmail SMTP (App Password) akun Anda sendiri.</li>
          <li>Analitik, template pesan, penjadwalan, dan kuota berbasis kredit.</li>
        </ul>
        <p>Kami dapat menambah, mengubah, atau menghentikan fitur tertentu dari waktu ke waktu demi peningkatan Layanan.</p>
      </Section>

      <Section id="penggunaan" title="5. Penggunaan yang Diizinkan">
        <p>
          Anda hanya boleh menggunakan Layanan untuk tujuan bisnis yang sah dan sesuai hukum Republik
          Indonesia, termasuk UU No. 11/2008 jo. UU No. 1/2024 tentang Informasi & Transaksi Elektronik (ITE)
          dan UU No. 27/2022 tentang Pelindungan Data Pribadi (PDP). Anda bertanggung jawab memastikan bahwa
          aktivitas pemasaran Anda mematuhi peraturan yang berlaku, termasuk memperoleh dasar yang sah untuk
          menghubungi penerima pesan.
        </p>
      </Section>

      <Section id="larangan" title="6. Larangan & Kebijakan Anti-Spam">
        <p>Anda <b>dilarang</b> menggunakan Layanan untuk:</p>
        <ul className={ul}>
          <li>Mengirim spam massal, penipuan (scam/phishing), atau konten yang melanggar hukum/SARA/pornografi.</li>
          <li>Mengirim pesan ke penerima tanpa dasar yang sah atau setelah penerima menolak (opt-out).</li>
          <li>Melanggar ketentuan platform pihak ketiga (mis. kebijakan WhatsApp, Google, Meta).</li>
          <li>Menyalahgunakan data pribadi orang lain, atau memperjualbelikan data secara melanggar hukum.</li>
          <li>Melakukan rekayasa balik, membebani sistem, atau mengganggu keamanan Layanan.</li>
        </ul>
        <p>Pelanggaran dapat mengakibatkan penangguhan atau penghentian akun tanpa pengembalian dana, serta tanggung jawab hukum pada Anda.</p>
      </Section>

      <Section id="byok" title="7. Akun Pihak Ketiga (BYOK — Bring Your Own Key)">
        <p>
          Sebagian fitur menggunakan akun pihak ketiga milik Anda sendiri (mis. token Fonnte untuk WhatsApp,
          atau Gmail App Password untuk Email). Anda bertanggung jawab penuh atas penggunaan, batas pengiriman,
          dan kepatuhan akun tersebut terhadap ketentuan penyedianya. {COMPANY.brand} tidak bertanggung jawab
          atas pemblokiran, suspensi, atau sanksi yang dijatuhkan penyedia pihak ketiga akibat aktivitas Anda.
        </p>
      </Section>

      <Section id="langganan" title="8. Langganan, Kredit & Harga">
        <ul className={ul}>
          <li>Layanan tersedia dalam paket gratis dan berbayar (bulanan/tahunan) serta paket kredit (PAYG).</li>
          <li>Langganan berbayar diperpanjang sesuai siklus yang dipilih; Anda dapat mengelola/menghentikan perpanjangan melalui halaman Billing.</li>
          <li>Kredit dipakai untuk fitur tertentu sesuai tarif yang ditampilkan; kredit bulanan dapat hangus tiap siklus, sedangkan kredit PAYG bersifat rollover sesuai ketentuan yang berlaku.</li>
          <li>Harga dapat berubah sewaktu-waktu; perubahan tidak berlaku surut atas periode yang telah dibayar.</li>
        </ul>
      </Section>

      <Section id="pembayaran" title="9. Pembayaran & Pajak">
        <p>
          Pembayaran diproses melalui mitra payment gateway resmi kami, yaitu <b>Midtrans</b> dan/atau
          <b> iPaymu</b>. Dengan melakukan pembayaran, Anda juga tunduk pada syarat penyedia pembayaran terkait.
          Kami <b>tidak menyimpan</b> data kartu/kredensial pembayaran Anda; data tersebut ditangani langsung
          oleh payment gateway. Harga yang ditampilkan dalam Rupiah (IDR) dan dapat termasuk atau belum termasuk
          pajak sesuai ketentuan; pajak yang berlaku menjadi tanggung jawab sesuai peraturan perpajakan Indonesia.
        </p>
      </Section>

      <Section id="refund" title="10. Pengembalian Dana">
        <p>
          Ketentuan pengembalian dana diatur tersendiri dalam{" "}
          <Link to="/refund" className={link}>Kebijakan Pengembalian Dana</Link>. Mohon membacanya sebelum
          melakukan pembelian.
        </p>
      </Section>

      <Section id="ki" title="11. Kekayaan Intelektual">
        <p>
          Seluruh hak atas Layanan, termasuk merek, logo, perangkat lunak, dan kontennya, adalah milik
          {" "}{COMPANY.brand} atau pemberi lisensinya. Anda diberikan lisensi terbatas, non-eksklusif, dan
          tidak dapat dialihkan untuk menggunakan Layanan sesuai Syarat ini. Data lead yang Anda kumpulkan
          tetap menjadi tanggung jawab Anda sebagai pengendali data.
        </p>
      </Section>

      <Section id="data" title="12. Data & Privasi">
        <p>
          Pengumpulan dan pemrosesan data pribadi dijelaskan dalam{" "}
          <Link to="/privacy" className={link}>Kebijakan Privasi</Link>. Untuk data bisnis/kontak yang Anda
          kumpulkan melalui Layanan, Anda bertindak sebagai pengendali data dan bertanggung jawab atas
          kepatuhan terhadap UU PDP.
        </p>
      </Section>

      <Section id="penafian" title="13. Penafian (Disclaimer)">
        <p>
          Layanan disediakan "sebagaimana adanya" dan "sebagaimana tersedia" tanpa jaminan apa pun, baik
          tersurat maupun tersirat. Kami tidak menjamin keakuratan, kelengkapan, atau ketersediaan data pihak
          ketiga, maupun bahwa Layanan akan selalu bebas gangguan atau kesalahan.
        </p>
      </Section>

      <Section id="tanggungjawab" title="14. Batasan Tanggung Jawab">
        <p>
          Sejauh diizinkan hukum, {COMPANY.brand} tidak bertanggung jawab atas kerugian tidak langsung,
          insidental, khusus, atau konsekuensial, termasuk kehilangan keuntungan, data, atau peluang bisnis.
          Total tanggung jawab kami atas klaim apa pun tidak melebihi jumlah yang Anda bayarkan kepada kami
          dalam 3 (tiga) bulan terakhir sebelum timbulnya klaim.
        </p>
      </Section>

      <Section id="gantirugi" title="15. Ganti Rugi (Indemnifikasi)">
        <p>
          Anda setuju untuk membebaskan dan mengganti rugi {COMPANY.brand} dari segala tuntutan, kerugian, atau
          biaya (termasuk biaya hukum yang wajar) yang timbul akibat pelanggaran Syarat ini atau penyalahgunaan
          Layanan oleh Anda.
        </p>
      </Section>

      <Section id="penangguhan" title="16. Penangguhan & Penghentian">
        <p>
          Kami dapat menangguhkan atau menghentikan akun yang melanggar Syarat, menyalahgunakan Layanan, atau
          atas dasar permintaan hukum. Anda dapat menutup akun kapan saja. Penghentian karena pelanggaran tidak
          memberikan hak atas pengembalian dana.
        </p>
      </Section>

      <Section id="hukum" title="17. Hukum yang Berlaku & Penyelesaian Sengketa">
        <p>
          Syarat ini diatur oleh hukum Republik Indonesia. Setiap sengketa akan diupayakan diselesaikan secara
          musyawarah terlebih dahulu. Apabila tidak tercapai, sengketa diselesaikan melalui jalur hukum yang
          berlaku di wilayah hukum Indonesia.
        </p>
      </Section>

      <Section id="perubahan" title="18. Perubahan Syarat">
        <p>
          Kami dapat memperbarui Syarat ini sewaktu-waktu. Perubahan material akan diberitahukan melalui situs
          atau email. Penggunaan Layanan setelah perubahan berlaku berarti Anda menyetujui Syarat yang
          diperbarui.
        </p>
      </Section>

      <Section id="kontak" title="19. Kontak">
        <p>
          Pertanyaan terkait Syarat ini dapat dikirim ke{" "}
          <a href={`mailto:${COMPANY.email}`} className={link}>{COMPANY.email}</a> atau WhatsApp{" "}
          <a href={`https://wa.me/${COMPANY.whatsapp}`} target="_blank" rel="noreferrer" className={link}>{COMPANY.whatsappDisplay}</a>.
        </p>
      </Section>
    </LegalLayout>
  );
}
